import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, sendPasswordResetEmail } from "firebase/auth";
import { XMarkIcon } from '@heroicons/react/24/outline';

function LoginModal({ onClose, onError }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onClose();
    } catch (error) {
      onError(error);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      onClose();
    } catch (error) {
      console.error("Error signing in with Google:", error);
      alert(error.message);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      alert("비밀번호를 재설정하려면 이메일을 입력해주세요.");
      return;
    }
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      alert("비밀번호 재설정 이메일을 보냈습니다. 이메일을 확인해주세요.");
    } catch (error) {
      console.error("Error sending password reset email:", error);
      alert(error.message);
    }
  };

  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4" onClick={handleOutsideClick}>
      <div className="bg-gray-800 bg-opacity-80 p-8 rounded-lg max-w-sm w-full m-1 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
        <h2 className="text-2xl font-bold mb-4 text-white">로그인</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 mb-4 border rounded bg-gray-700 text-white"
            autoComplete="username"
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 mb-4 border rounded bg-gray-700 text-white"
            autoComplete="current-password"
          />
          <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded mb-4 hover:bg-blue-700">로그인</button>
        </form>
        <button onClick={handleGoogleSignIn} className="w-full bg-red-500 text-white p-2 rounded mb-4 hover:bg-red-600">
          Google로 로그인
        </button>
        <div className="flex justify-between text-xs">
          <button onClick={handlePasswordReset} className="text-blue-300 hover:underline">
            비밀번호 재설정
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
